import { useRef } from 'react'
import { useClickAway } from 'react-use'
import type { PayIdDetails } from '@/wallet/types'
import { Dialog, DialogContent } from '@/common/ui/dialog'
import { AddFundsForm } from './features/add-funds/components/AddFundsForm'
import { useAddFundsLogic } from './features/add-funds/useAddFundsLogic'

interface AddFundsModalProps {
    open: boolean
    onClose: () => void
    payIdDetails?: PayIdDetails
}

export default function AddFundsModal({ open, onClose, payIdDetails }: AddFundsModalProps) {
    const fundsModalRef = useRef(null)
    useClickAway(fundsModalRef, () => {
        onClose()
    })

    const { onHavePaidClick, onWillTransferLaterClick, introText } = useAddFundsLogic({
        payIdDetails,
        onClose,
    })

    if (!open) return null

    return (
        <Dialog open={open}>
            <DialogContent
                ref={fundsModalRef}
                onClose={onClose}
                className="px-10 py-14 max-h-[90vh] max-w-[600px] overflow-y-auto"
            >
                <AddFundsForm
                    payIdDetails={payIdDetails}
                    onHavePaidClick={onHavePaidClick}
                    onWillTransferLaterClick={onWillTransferLaterClick}
                    introText={introText}
                />
            </DialogContent>
        </Dialog>
    )
}
